import React from "react";
import { StyleSheet, Dimensions, View } from "react-native";
import Video from "react-native-video";
import Player from "./Player";

const { width, height } = Dimensions.get("screen");

const Player2 = (props) => {
  return (
    <View
      style={{
        flex: 1,
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Video
        resizeMode="contain"
        {...props}
        source={{
          uri: props.videoLink,
        }}
        style={styles.container}
      />
    </View>
  );
};

const VideoPlayer = (props) => {
  if (props.isSecondPlayer) {
    return <Player2 {...props} />;
  }
  return <Player {...props} />;
};

const styles = StyleSheet.create({
  container: {
    position: "absolute",
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    width,
    height,
  },
});

export default VideoPlayer;
